<template>
  <div>
    <bv-top></bv-top>
    <van-notice-bar mode="link" left-icon="info-o" @click="houseDepositClick" ref="topBar">
      本功能仅支持已交存的房屋进行绑定，若未交存请先进行交存，交存后房屋会自动绑定，点这里去交存
    </van-notice-bar>
    <p class="regionTitle" ref="topTitle">认证房屋</p>
    <van-cell-group>
      <van-field
        v-model="regionName"
        required
        clearable
        label="小区名称"
        placeholder="请输入小区名称"
        @focus="regionInputFocus"
      >
      </van-field>

      <van-field
        readonly
        required
        clickable
        label="房屋坐落"
        :value="currentHouse"
        placeholder="房屋坐落"
        @click="houseInputClick"/>

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          :title="currentHouse"
          show-toolbar
          :columns="housePickerColumns"
          :loading="loading"
          @cancel="housePickerCancel"
          @confirm="housePickerConfirm"
          @change="housePickerChange"
        />
      </van-popup>
    </van-cell-group>
    <van-row type="flex" justify="center">
      <van-col span="22">
        <van-button class="footBtn" size="large" type="primary" @click="bindUserHouse">绑定房屋</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
  import {fetchBldCellHouses, regions, userHouses} from '@/api/maintainFund/maintainFund'
  import {NoticeBar} from 'vant'
  import Top from '@/views/components/Top'

  export default {
    name: 'BindingHouse',
    components: {
      BvTop: Top,
      VanNoticeBar: NoticeBar
    },
    data() {
      return {
        defaultCell: [],
        defaultHouse: [],
        fullHeight: '',
        logo: require('@/assets/logo.png'),
        regionName: '',
        regions: [],
        searchShow: false,
        currentRegion: '',
        regionNo: '',
        region: {},
        blds: [],
        cells: [],
        houses: [],
        housePickerColumns: [],
        message: {
          show: true,
          message: '请选择楼栋'
        },
        showPicker: false,
        loading: false,
        currentHouse: '',
        bld: '',
        cell: '',
        house: '',
        address: ''
      }
    },
    mounted() {
      if (this.$route.query.region) {
        this.region = this.$route.query.region;
        this.divisionCode = this.region.divisionCode;
        this.regionName = this.region.regionName;
        this.currentRegion = this.region.regionName;
        this.regionNo = this.region.regionNo;
      }
    },
    watch: {
      regionName(val) {
        if (val && val != this.currentRegion) {
          let param = {
            regionName: val
          };
          regions(param).then(response => {
            if (response.data.length === 0) {
              this.searchShow = false
            } else {
              this.regions = response.data;
              this.searchShow = true;
            }
          })
        } else {
          this.currentHouse = '';
          this.searchShow = false
        }
      }
    },
    methods: {
      regionInputFocus() {
        this.$router.push({path: '/maintainFund/regions', query: {label: decodeURI(this.$route.query.label)}})
      },
      bindUserHouse() {
        let param = {
          divisionCode: this.divisionCode,
          regionNo: this.regionNo,
          bldNo: this.bld,
          cellNo: this.cell,
          houseNo: this.house,
          address: this.address
        };
        userHouses(param).then(res => {
          if (res.status === 200) {
            this.$dialog.alert({
              message: '房屋绑定成功'
            }).then(() => {
              this.$router.push({path: '/maintainFund'})
            });
          }
        })
      },
      houseDepositClick() {
        this.$router.push({path: '/maintainFund/houseDeposit', query: {label: '房屋交存'}})
      },
      houseInputClick() {
        if (this.regionNo) {
          let param = {
            regionNo: this.regionNo
          };
          fetchBldCellHouses(param).then(response => {
            const data = response.data;
            this.$set(this.housePickerColumns, 0, {
              values: data[0]
            });
            this.$set(this.housePickerColumns, 1, {
              values: data[1]
            });
            this.$set(this.housePickerColumns, 2, {
              values: data[2]
            });
            this.showPicker = true;
            if (this.currentHouse === '') {
              //获取后台返回默认值，往选择楼栋页面位置展示
              this.currentHouse = data[0][0].text + '-' + data[1][0].text + '-' + data[2][0].text
            } else {
              //获取用户选择获得值，往选择楼栋页面位置展示
              this.$set(this.housePickerColumns, 1, {
                values: this.defaultCell
              });
              this.$set(this.housePickerColumns, 2, {
                values: this.defaultHouse
              });
            }
          })
        }
      },
      housePickerConfirm(values) {
        if (values[0] && values[1] && values[2]) {
          this.currentHouse = values[0].text + '-' + values[1].text + '-' + values[2].text;
          this.showPicker = false;
        } else {
          this.$toast.fail("请选择绑定房屋...");
          return;
        }
      },
      housePickerCancel() {
        this.showPicker = false;
      },
      housePickerChange(picker, values, index) {
        let that_ = this;
        if (values[0]) {
          that_.bld = values[0].key;
        }
        if (values[1]) {
          that_.cell = values[1].key;
        }
        if (values[2]) {
          that_.house = values[2].key;
        }
        let param = {
          regionNo: this.regionNo
        };
        if (index === 0) {
          that_.loading = true;
          param.bldNo = that_.bld;
          fetchBldCellHouses(param).then(response => {
            const data = response.data;

            this.$set(this.housePickerColumns, 1, {
              values: data[0]
            });
            this.$set(this.housePickerColumns, 2, {
              values: data[1]
            });

            if (data[0].length > 0 && data[1].length > 0) {
              this.currentHouse = values[0].text + '-' + data[0][0].text + '-' + data[1][0].text;
            } else {
              this.currentHouse = '';
            }

            that_.loading = false;
          })
        }
        if (index === 1) {
          that_.loading = true;
          param.bldNo = that_.bld;
          param.cellNo = that_.cell;
          fetchBldCellHouses(param).then(response => {
            const data = response.data;
            this.$set(this.housePickerColumns, 2, {
              values: data[0]
            });
            if (data[0].length > 0) {
              this.currentHouse = values[0].text + '-' + values[1].text + '-' + data[0][0].text;
            } else {
              this.currentHouse = '';
            }

            that_.loading = false
          })
        }
        if (index === 2) {
          this.address = values[2].extra;
          this.currentHouse = values[0].text + '-' + values[1].text + '-' + values[2].text;
          this.defaultCell = values[1].text;
          this.defaultHouse = values[2].text;
        }
      }
    }
  }
</script>

<style lang='scss'>
  .regionTitle {
    font-size: 14px;
    border-left: solid 5px #2acba3;
    margin-left: 15px;
    padding-left: 10px
  }

  .regionList {
    z-index: 100;
    position: absolute;
    width: 100vw;
    display: inline !important;
    list-style: none;
    overflow-y: scroll;
    line-height: 2;
    border-radius: 6px;
    background: white;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  }

  .footBtn {
    background-color: #2acba2 !important;
    border: 1px solid #2acba2 !important;
    border-radius: 5px;
  }
</style>
